<template>
  <el-dialog class="autotag-edit" :visible.sync="visible" :title="ruleForm.userId ? '编辑' : '新增'" @closed="closed">
    <el-form ref="ruleForm" v-loading="loading" :model="ruleForm" class="form" :rules="rules" label-position="top">
      <div class="wrapper">
        <div class="form-container">
          <!--          <div class="head">-->
          <!--            <span>头像</span>-->
          <!--            <div>-->
          <!--              <div class="headImage">-->
          <!--                <img :src="ruleForm.avatar ? ruleForm.avatar : avatarImage">-->
          <!--                <div class="upload">-->
          <!--                  <div class="upload__tip">-->
          <!--                    格式：jpg、png，大小：2M以内-->
          <!--                  </div>-->
          <!--                  <el-upload-->
          <!--                    class="upload-demo"-->
          <!--                    action-->
          <!--                    :show-file-list="false"-->
          <!--                    :http-request="uploadSectionFile"-->
          <!--                    :before-upload="beforeAvatarUpload"-->
          <!--                  >-->
          <!--                    <el-button size="small" icon="el-icon-upload2">-->
          <!--                      上传文件-->
          <!--                    </el-button>-->
          <!--                  </el-upload>-->
          <!--                </div>-->
          <!--              </div>-->
          <!--            </div>-->
          <!--          </div>-->
          <el-form-item label="姓名" class="form-item required" prop="nickName">
            <el-input
              v-model="ruleForm.nickName"
              size="small"
              placeholder="请输入姓名"
              clearable
            />
          </el-form-item>
          <el-form-item label="手机号码" class="form-item required" prop="phone">
            <el-input
              v-model="ruleForm.phone"
              size="small"
              clearable
              placeholder="请输入手机号码"
            />
          </el-form-item>
          <el-form-item label="邮箱" prop="email">
            <el-input
              v-model.trim="ruleForm.email"
              size="small"
              clearable
              placeholder="请输入邮箱"
              :disabled="id ? true : false"
            />
          </el-form-item>
          <el-form-item label="管理公司" prop="companyIdList">
            <el-select v-model="ruleForm.companyIdList" multiple collapse-tags size="small" placeholder="请选择管理公司">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :disabled="item.disabled"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <div class="form-btn">
              <el-button class="cancel-btn" @click="closed()">
                取 消
              </el-button>
              <el-button class="true-btn" @click="submitForm('ruleForm')">
                保 存
              </el-button>
            </div>
          </el-form-item>
        </div>
      </div>
    </el-form>
  </el-dialog>
</template>
<script>
import avatarImage from '@/assets/images/avatar.png'
import { addUser, editUser, sysCompanyPage } from '@/api/index'
export default {
  data() {
    return {
      visible: false,
      loading: false,
      avatarImage,
      ruleForm: {
        isCompanyAdminInsert: 1,
        type: 2,
        userId: '',
        nickName: '',
        avatar: '',
        email: '', // 邮箱
        phone: '',
        companyIdList: []
      },
      rules: {
        nickName: [
          { required: true, message: '请输入姓名', trigger: 'change' }
        ],
        phone: [
          { required: true, message: '请输入手机号码', trigger: 'change' }
        ],
        email: [
          { required: true, message: '请输入邮箱', trigger: 'change' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
        ],
        companyIdList: [
          { required: true, message: '请选择管理公司', trigger: 'change' }
        ]
      },
      options: [],
      id: ''
    }
  },
  mounted() {
    this.getSysCompanyPage()
  },
  methods: {
    getSysCompanyPage() {
      const data = {
        current: 1,
        size: 9999
      }
      sysCompanyPage(data).then((res) => {
        if (res.data) {
          this.options = res.data.records.map(item => {
            return { label: item.companyName, value: item.id }
          })
        }
      })
    },
    closed() {
      this.$refs['ruleForm'].resetFields()
      this.ruleForm.userId = ''
      this.ruleForm.avatar = ''
      this.visible = false
    },
    init(row) {
      this.visible = true
      this.$nextTick(() => { // 注意看这里
        if (row) {
          this.id = row.userId
          this.ruleForm.nickName = row.nickName
          this.ruleForm.avatar = row.avatar
          this.ruleForm.email = row.email
          this.ruleForm.phone = row.phone
          this.ruleForm.userId = row.userId
          this.ruleForm.companyIdList = row.companyVoList ? row.companyVoList.map(item => {
            if (item.isCompanyAdmin === 1) {
              return item.companyId
            }
          }).filter(f => f) : []
        }
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.ruleForm.userId) {
            this.getEditUser()
          } else {
            this.getAddUser()
          }
        } else {
          return false
        }
      })
    },
    getAddUser() {
      this.loading = true
      const data = {
        role: [2],
        username: this.ruleForm.email,
        ...this.ruleForm
      }
      addUser(data).then((res) => {
        this.loading = false
        if (res.code === 0) {
          this.visible = false
          this.$message({
            type: 'success',
            message: '操作成功!'
          })
          this.$emit('fresh')
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    getEditUser() {
      this.loading = true
      const data = {
        ...this.ruleForm
      }
      editUser(data).then((res) => {
        this.loading = false
        if (res.code === 0) {
          this.visible = false
          this.$message({
            type: 'success',
            message: '操作成功!'
          })
          this.$emit('fresh')
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 接口
    uploadSectionFile(param) {
      const formData = new FormData()
      formData.append('file', param.file)
      // 接口
    },

    // 上传图片之前
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isJPG && !isPNG) {
        this.$message.error('上传图片只能是 JPG 或者 PNG格式!')
      } else {
        if (!isLt2M) {
          this.$message.error('上传图片大小不能超过 2MB!')
        }
      }
      return (isJPG || isPNG) && isLt2M
    }
  }
}
</script>
<style scoped lang="scss">
  .wrapper {
    .form-container {
      width: 400px;
      margin: 0 auto;
      ::v-deep .el-form-item {
        margin-bottom: 14px;
        .el-form-item__label{
          padding-bottom: 0px;
          line-height: 26px;
        }
      }
      ::v-deep .el-select {
        width: 100%;
      }
      .head{
        width: 100%;
        margin-bottom: 18px;
        >span{
          color: #646A73;
          font-size: 14px;
        }
        >div{
          display: flex;
          display: -webkit-flex;
          flex-wrap: wrap;
          justify-content: space-between;
          margin-top: 8px;
          .headImage{
            display: flex;
            display: -webkit-flex;
            img{
              width: 60px;
              height: 60px;
              border-radius: 4px;
              margin-right: 12px;
            }
            .upload{
              .upload__tip{
                color: #646A73;
                font-size: 12px;
                margin-bottom: 11px;
              }
            }
          }

          .tag-status{
            display: flex;
            display: -webkit-flex;
            justify-content: flex-end;
            >span{
              color: #8691A3;
              font-size: 16px;
              margin-right: 8px;
            }
            .tag-status-info{
              width: 67px;
              height: 24px;
              line-height: 24px;
              background: #E1EAFF;
              border-radius: 12px;
              display: flex;
              align-items: center;
              >img {
                width: 14px;
                height: 14px;
                margin-right: 8px;
                margin-left: 5px;
              }
              >span {
                font-size: 14px;
                font-weight: 400;
              }
            }
          }
        }
      }
      .form-btn {
        margin-top: 26px;
        display: flex;
        justify-content: flex-end;
        .cancel-btn {
          width: 66px;
          height: 32px;
          background: #FFFFFF;
          border-radius: 4px;
          border: 1px solid #DFE0E3;
          padding: 0px;
          font-size: 14px;
          font-weight: 400;
          color: #1F2329;
        }
        .true-btn {
          width: 66px;
          height: 32px;
          background: #3370FF;
          border-radius: 4px;
          padding: 0px;
          font-size: 14px;
          font-weight: 400;
          color: #FFFFFF;
          border: 1px solid #3370FF;
        }
      }
    }
  }
</style>
